import type { AccountingEntry } from '../../../types/models/Reconciliation';

// The WinAuditor OD import file (« Exporter pour WinAuditor »): one .xlsx per OD (journal `misc`), downloaded
// from `GET /admin/reconciliation/accounting-entries/winauditor-od` and imported by Sophie herself
// (« Opérations diverses > Ajouter > Importer à partir d'Excel »). The backend re-checks every rule below.

export const WINAUDITOR_OD_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** Only an OD (journal `misc`) can be exported to WinAuditor. */
export const isExportableJournal = (entry: AccountingEntry): boolean => entry.journal === 'misc';

/**
 * Why the OD cannot be exported yet (French), or null when it can: a customer line without its WinAuditor
 * code (flag `winauditor_code_missing`, `winauditor_account.code` null).
 */
export function odExportBlocker(entry: AccountingEntry): string | null {
  const missing =
    entry.flags.includes('winauditor_code_missing') ||
    entry.lines.some((l) => l.winauditor_account !== undefined && l.winauditor_account.code === null);
  return missing
    ? "Un client de cette OD n'a pas de code WinAuditor : saisissez-le dans « Codes clients WinAuditor » pour l'exporter."
    : null;
}

/**
 * The backend's own filename (`OD-{date}-{reference}.xlsx`, anything but letters, digits, `.`, `_`, `-`
 * replaced by `-`). Built here because the API does not expose `Content-Disposition` to the browser (CORS).
 */
export function winauditorOdFilename(entry: AccountingEntry): string {
  return `OD-${entry.date}-${(entry.reference ?? entry.id).replace(/[^A-Za-z0-9._-]+/g, '-')}.xlsx`;
}

/** The `filename="…"` of a Content-Disposition header, or null. */
export function filenameFromContentDisposition(header: string | null): string | null {
  const match = header?.match(/filename="([^"]+)"/);
  return match ? match[1] : null;
}
